/** @flow */

import {
  GetAlertsList,
  GetAlertsListSuccess,
  GetAlertsListError,
  GetAlert,
  GetAlertSuccess,
  GetAlertError,
  GetAlertSchema,
  GetAlertSchemaSuccess,
  GetAlertSchemaError,
  NewAlert,
  DuplicateAlertSuccess,
  StartDraftAlertSuccess,
  SetAlertDraft,
  NewAlertAssignments,
  SetAlertAssignments,
  SetAlertsEnabled,
  SetAlertsStatus,
  SetAlertModalStep,
  SetShowAddAlertModal,
  SetShowEditAlertModal,
  SetShowEditAlertAssignmentsModal,
  SetShowAddAlertRecipientModal,
  SetShowDeleteAlertRecipientModal,
  SetShowDiscardAlertModal,
  SetShowSubmitAlertModal,
  SetShowDisableAlertModal,
  SetShowCancelAlertModal,
  SetShowCancelDiscardAlertModal,
  SetShowAddAlertAttachmentModal,
  SetShowDeleteAlertAttachmentModal,
  SetAlertDraftAssignments,
  AddAlert,
  AddAlertSuccess,
  UpdateAlert,
  UpdateAlertSuccess,
  UpdateAlertError,
} from "@modules/service/constants/actions";
import * as alertsReducers from "./reducers";
import initialState from "./state";
import type { AlertsState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: AlertsState = initialState, action: Object): AlertsState => {
  const act = {
    [UpdateAlert]: alertsReducers.onUpdateAlert,
    [UpdateAlertSuccess]: alertsReducers.onUpdateAlertSuccess,
    [UpdateAlertError]: alertsReducers.onUpdateAlertError,
    [AddAlert]: alertsReducers.onAddAlert,
    [AddAlertSuccess]: alertsReducers.onAddAlertSuccess,
    [GetAlertsList]: alertsReducers.onGetAlertsList,
    [GetAlertsListSuccess]: alertsReducers.onGetAlertsListSuccess,
    [GetAlertsListError]: alertsReducers.onGetAlertsListError,

    [GetAlert]: alertsReducers.onGetAlert,
    [GetAlertSuccess]: alertsReducers.onGetAlertSuccess,
    [GetAlertError]: alertsReducers.onGetAlertError,

    [GetAlertSchema]: alertsReducers.onGetSchema,
    [GetAlertSchemaSuccess]: alertsReducers.onGetSchemaSuccess,
    [GetAlertSchemaError]: alertsReducers.onGetSchemaError,

    [NewAlert]: alertsReducers.onNew,
    [DuplicateAlertSuccess]: alertsReducers.onDuplicateSuccess,
    [StartDraftAlertSuccess]: alertsReducers.onStartDraftSuccess,
    [SetAlertDraft]: alertsReducers.onSetDraft,

    [NewAlertAssignments]: alertsReducers.onNewAssignments,
    [SetAlertAssignments]: alertsReducers.onSetAssignments,
    [SetAlertDraftAssignments]: alertsReducers.onSetAlertDraftAssignments,

    [SetAlertsEnabled]: alertsReducers.onSetEnabled,
    [SetAlertsStatus]: alertsReducers.onSetStatus,

    [SetAlertModalStep]: alertsReducers.onSetModalStep,
    [SetShowAddAlertModal]: alertsReducers.onSetShowAddModal,
    [SetShowEditAlertModal]: alertsReducers.onSetShowEditModal,
    [SetShowEditAlertAssignmentsModal]: alertsReducers.onSetShowEditAssignmentsModal,
    [SetShowAddAlertRecipientModal]: alertsReducers.onSetShowAddAlertRecipientModal,

    [SetShowDeleteAlertRecipientModal]: alertsReducers.onSetShowDeleteAlertRecipientModal,
    [SetShowDiscardAlertModal]: alertsReducers.onSetShowDiscardModal,
    [SetShowSubmitAlertModal]: alertsReducers.onSetShowSubmitModal,
    [SetShowDisableAlertModal]: alertsReducers.onSetShowDisableModal,
    [SetShowCancelAlertModal]: alertsReducers.onSetShowCancelModal,
    [SetShowCancelAlertModal]: alertsReducers.onSetShowCancelModal,
    [SetShowCancelDiscardAlertModal]: alertsReducers.onSetShowCancelDiscardModal,
    [SetShowAddAlertAttachmentModal]: alertsReducers.onSetShowAddAlertAttachmentModal,

    [SetShowDeleteAlertAttachmentModal]: alertsReducers.onSetShowDeleteAlertAttachmentModal,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
